module.exports = __webpack_public_path__ + "img/table.e810518d.png";